import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";

const PenaltyRules = () => {
  return (
    <div className="terms content_page">
      <div className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt-5">
              <div className="terms-info-wraps">
                {/* <Breadcrumb name={"Penalty Rules"} pageName={"Penalty Rules"} /> */}
                <div className="privacy-area">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="privacy-info-wraps">
                          <h4>Penalty Rules for Classhila Educators</h4>
                        <p>At Classhila, we are committed to delivering an exceptional learning experience to our learners.
                        To ensure this, all educators are expected to adhere to the following guidelines:</p>
                          <ul>
                            <li>Begin your class on time or at least 15 minutes prior to the scheduled start.</li>
                            <li>Follow the Class Rescheduling Policy by rescheduling classes at least 72 hours before
                            the scheduled start.</li>
                            <li>Wear Classhila’s Yellow T-Shirt during Live Classes and display the Classhila logo on
                            your shirt or jacket to the camera at least once, allowing the system to detect it.</li>
                            <li>Complete class hours as scheduled.</li>
                            <li>Do not share personal information or communication methods during Plus and Special
                            Classes.</li>
                            <li>Ensure all classes (Live/Recorded/Free/YouTube) are completed as scheduled.</li>
                           
                          </ul>
                          <p>Educators are encouraged to provide high-quality content and maintain decorum during Live
Classes. If any behavior negatively impacts the learner experience, penalties will be applied as
outlined below.</p>

                          <h4>A. Penalty for Misconduct in Class</h4>
                          <p>For each instance of misconduct, 1% of the Educator’s Base Pay will be deducted. Misconduct
                          includes:</p>
                          <ul>
                            <li>A delay of more than 6 minutes in starting the class.</li>
                            <li>Rescheduling a Class within 24 to 72 hours before the Go-Live time (as per the Class
                                Rescheduling Policy).</li>
                            <li>Failure to wear Classhila&#39;s Yellow T-shirt or jacket during Live Classes.</li>
                            <li>Missing a scheduled class.</li>
                            <li>Leaving a Live Class for more than 5 minutes without a valid reason.</li>
                            
                          </ul>

                          <h4>B. Penalty for Class Rescheduling</h4>
                          <ul>
                            <li>Rescheduling the Class within 24 hours of the Go-Live time will result in a 2% deduction
                            from Base Pay for each occurrence.</li>
                            <li>Rescheduling a the Class between 24 to 72 hours before the Go-Live time will result in a
                            1% deduction from Base Pay for each occurrence.</li>
                          </ul>

                          <h4>C. Penalty for Sharing Personal Telegram Channel Details</h4>
                          <p>If an educator shares their personal Telegram channel link or any other unauthorized details
                          during a Live Class (Subscription/Special/YouTube), the following penalties will apply:</p>
                          <ul>
                            <li>First instance: Rs. 20,000 fine with a reminder.</li>
                            <li>Second instance: Rs. 50,000 fine with a breach notice.</li>
                            <li>Third instance: Termination of the Educator Agreement and account suspension at
                            Classhila’s discretion.</li>
                          </ul>

                          <h4>D. Penalty for Misuse of Educator Referral Codes</h4>
                          <p>If an educator offers more than a 10% discount to learners to boost subscriptions (or engages in
                            unauthorized promotional activities), the following penalties will apply:</p>
                          <ul>
                            <li>First instance: Rs. 20,000 fine with a reminder.</li>
                            <li>Second instance: Rs. 30,000 fine with a breach notice.</li>
                            <li>Third instance: Termination of the Educator Agreement and account suspension at
                            Classhila’s discretion.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenaltyRules;
